import React from "react";
import { FaAward } from "react-icons/fa";
import { FaPercent } from "react-icons/fa";
import { FaWallet } from "react-icons/fa";
import { FiArrowUpRight } from "react-icons/fi";

const VisaServicesSection = () => {
  const services = [
    {
      icon: <FaAward className="text-white text-2xl" />,
      bg: "bg-yellow-400",
      title: "Local Guidance",
      desc: "Travel agencies have experienced professionals guidance.",
    },
    {
      icon: <FaPercent className="text-white text-2xl" />,
      bg: "bg-blue-500",
      title: "Deals & Discounts",
      desc: "Agencies have special discounts on flights, hotels, & packages.",
    },
    {
      icon: <FaWallet className="text-white text-2xl" />,
      bg: "bg-yellow-400",
      title: "Saves Money",
      desc: "Avoids hidden fees & tourist traps, Multi-destination & budget-friendly options.",
    },
  ];

  return (
    <section className="py-16 bg-[#E7F3FF] px-6 lg:px-16">
      <div className="bg-blue-100 border border-blue-300 rounded-3xl p-10 lg:p-16 shadow-sm">

        {/* Top Title */}
        <div className="text-center mb-10">
         

          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">
            We’re Providing Best Service Ever!
          </h2>
        </div>

        {/* Divider Line with Small Triangle */}
        <div className="relative mb-10">
          <div className="h-[1px] w-full bg-blue-300"></div>
          <div className="absolute left-1/2 -top-[5px] -translate-x-1/2 w-0 h-0 border-l-[6px] border-r-[6px] border-b-[6px] border-transparent border-b-blue-300"></div>
        </div>

        {/* Services */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {services.map((item, index) => (
            <div key={index} className="flex items-start gap-4">
              {/* Icon */}
              <div className={`${item.bg} p-4 rounded-full flex items-center justify-center`}>
                {item.icon}
              </div>

              {/* Text */}
              <div>
                <h3 className="text-xl font-semibold text-gray-900">
                  {item.title}
                </h3>
                <p className="text-gray-600 mt-2 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Offer Button */}
        <div className="flex justify-center">
          <button className="bg-blue-600 hover:bg-blue-700 transition-all duration-300 text-white font-semibold px-8 py-4 rounded-full flex items-center gap-4 text-sm md:text-base shadow-md">
            Flat 30% Discounts All Packages
          
          </button>
        </div>
      </div>
    </section>
  );
};

export default VisaServicesSection;
